export const HUNDRED_MB_FILE_CHUNK_SIZE = 100 * 1024 * 1024; // 100 MB
export const TEN_MB_FILE_CHUNK_SIZE = 10 * 1024 * 1024; // 10 MB

export const MAX_CONCURRENT_PARTS = 6;

export const PROGRESS_THROTTLE = 300;

export const REMOVE_COMPLETED_DELAY = 3000;

export const ASSET_STATUS = {
  UPLOADED: 'UPLOADED',
  IN_PROGRESS: 'IN_PROGRESS',
  MISSING: 'MISSING'
};

export const ITEM_STATUS = {
  DEFAULT: 'default',
  ACTIVE: 'active',
  SUCCESS: 'success',
  ERROR: 'error'
};